import {HTMLAttributes} from "react";
import {ComponentChildren} from "preact";
import {useState} from "preact/hooks";
import {mdiCheckboxBlankCircleOutline, mdiCheckboxMarkedCircleOutline} from "@mdi/js";
import Icon from "@mdi/react";

type CheckboxProps = {
    label: ComponentChildren;
    checked?: boolean;
} & Omit<HTMLAttributes<HTMLInputElement>, "checked" | "label">;

export function Checkbox({label, checked, ...props}: CheckboxProps) {
    const UNCHECKED = mdiCheckboxBlankCircleOutline;
    const CHECKED = mdiCheckboxMarkedCircleOutline;

    const [checkedState, setChecked] = useState<boolean>(checked ?? false);

    return <label class={"for-checkbox" + (checkedState ? " checkbox-checked" : "")}>
        <input type="checkbox" onChange={(e) => {
            setChecked(!checkedState);
        }} checked={checkedState} {...props} />
        <Icon path={checkedState ? CHECKED : UNCHECKED} size="1em" />
        {label}
    </label>
}
